export default {
  default: () => import("/root/workspace/edu-cert-plat-fe_6hRV/src/layouts/default.vue").then(m => m.default || m)
}